<mat-radio-button class="location" [value]="locationDetails.location_id">
    <div class="container">
        <div class="details">
            <div class="bold-text">
                {{ locationDetails.location_name }}
            </div>
            <div class="address">
                {{ locationDetails.address }}
            </div>
        </div>

        <div class="distance">
            <div>{{ locationDetails.distance }} mi</div>
        </div>

        <div
            class="store-hours"
            [innerHTML]="locationDetails.store_hours_display"
        ></div>
    </div>
</mat-radio-button>
